<script> 
	import { 
		headerTitleHome, 
		linkAV,
		linkConheca,
		linkSolicite,
		linkPesquisaVendas,
		linkPesquisaLocacao,
		linkInstagram,
	} from '../store.js';
	
	import { link }         		from "svelte-routing";
	import { onMount, onDestroy  }	from 'svelte';
	import Instagram				from '../components/Instagram.svelte'

	import Boleto           		from '../components/Boleto.svelte'
	import PopUp					from '../components/PopUp.svelte'
	import Forms					from "../components/Forms.svelte";  
	import Vitrine					from '../components/Vitrine.svelte'
	import Busca					from '../components/Busca.svelte'
	import ListaImoveis				from '../components/ListaImoveis.svelte'
	

	let vitrines = [
		{
			image: 'vitrineImovel578.jpg', 
			imageMobile: 'vitrineImovel578M.jpg', 
			title: 'Oferta',
			href: 'https://saopedroimoveis.com.br/imovel/Loca%C3%A7%C3%A3o/187/imovel-Sala-em-Cristal-Porto-Alegre-Cod-578'
		},
		{
			image: 'vitrineImovelV579_2.jpg', 
			imageMobile: 'vitrineImovelV579M.jpg', 
			title: 'Oferta',
			href: 'https://saopedroimoveis.com.br/imovel/Venda/192/imovel-Apartamento-em-Menino-Deus-Porto-Alegre-Cod-V579'
		},
		{
			image: 'vitrineImovelV569.jpg', 
			imageMobile: 'vitrineImovelV569M.jpg', 
			title: 'Oferta',
			href: 'https://saopedroimoveis.com.br/go-imovel/Venda/178/imovel-Apartamento-em-Menino-Deus-Porto-Alegre-Cod-V569'
		},
		{
			image: 'vitrinePredio.jpg', 
			imageMobile: 'vitrinePredioM.jpg', 
			title: 'Oferta',
			href: 'https://saopedroimoveis.com.br/imovel/Venda/91/imovel-Pr%C3%A9dio-em-Santa-Tereza-Porto-Alegre-Cod-V373'
		},
		{
			image: 'vitrineAlugar.jpg', 
			imageMobile: 'vitrineAlugarM.jpg', 
			title: 'Alugar',
			href: $linkPesquisaLocacao
		},
		{
			image: 'vitrineComprar.jpg', 
			imageMobile: 'vitrineComprarM.jpg', 
			title: 'Comprar',
			href: $linkPesquisaVendas
		},
		{
			image: 'vitrineAV.jpg', 
			imageMobile: 'vitrineAVM.jpg', 
			title: 'App',
			href: $linkConheca,
			target: '_blank'
		},
	];
	
	function toggleMenu() {
		document.querySelector('header.header--hidden').classList.toggle('hidden');
	}

	function search(e) {
		const url = '/imoveis/' + (e.detail.tipo_negociacao == atria.rent?'locacao':'vendas') + '#' + Object.entries(e.detail).filter(p=>p[1].toString().length>0&&p[1].toString()!='0').flatMap(p=>`${p[0]}=${encodeURI(p[1])}`).join('&');
		document.location = url;
	}

	let fields = [
		{
			title:      'Seu nome *',
			name:       'nome',
			required:   'required',
			rowclass: 'flex-1'
		},
		{
			title:      'Telefone *',
			name:       'telefone',
			required:   'required',
			classe:     'mask-telefone',
			rowclass: 'flex-1'
		},
		{
			title:      'Email *',
			name:       'email',
			required:   'required',
			type:       'email',
			rowclass: 'flex-1'
		},
		{
			title:      'Você é síndico?',
			name:       'eh-sindico',
			type:       'select',
			rowclass: 'flex-1',
			selectValues: [
				{
					title: 'Você é síndico?',
					value: ''
				},
				{
					title: 'Sim',
					value: 'Sim'
				},
				{
					title: 'Não',
					value: 'Não'
				}
			]
		},          
		{
			title:      'Nome do condomínio *',
			name:       'condominio-nome',
			required:   'required',
			rowclass: 'flex-1'
		}
	];
	
	const message = `
Seu nome: {nome}
Telefone: {telefone}
Email: {email}
Você é síndico?: {eh-sindico}
Nome do condomínio: {condominio-nome}

{info}`;

	let loading = false;
	function send() {
		loading = true;
	}

	let filtrosDestaquesLocacao = {nt:atria.rent, tipo_negociacao:atria.rent, pageSize:6, random: 1};
	let filtrosDestaquesVendas = {nt:atria.sell, tipo_negociacao:atria.sell, pageSize:6, random: 1};

	function activateSlickLocacao(json) {
		if (json.NumberOfItems == 0) {
			document.querySelector('.destaques-home--locacao').style.display = 'none';
		} else {
			activateSlick('.destaques-home--locacao');
		}
	}
	function activateSlickVendas(json) {
		if (json.NumberOfItems == 0) {
			document.querySelector('.destaques-home--vendas').style.display = 'none';
		} else {
			activateSlick('.destaques-home--vendas');
		}
	}
	function activateSlick(selector) {
		window.setTimeout(()=>{            
			jQuery(selector).show();
			jQuery(selector + ' .row').slick({
				infinite: true,
				speed: 400,
				slidesToShow: 3,
				slidesToScroll: 3,
				autoplay: true,
				arrows: false,
				dots: true,
				responsive: [
					{
						breakpoint: 1200,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2,
							dots: true,
							arrows: false,
						}
					},
					{
						breakpoint: 850,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2,
							dots: true,
							arrows: false,
						}
					},
					{
						breakpoint: 500,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
							dots: true,
							arrows: false,
						}
					}
				]
			});
		}, 500);
	}

	//Esconde cabecalho
	onMount(async () => {
		document.querySelector('body').classList.add('site--home');
	});
	onDestroy(async () => {
		document.querySelector('body').classList.remove('site--home');
		document.querySelector('header').classList.remove('hidden');
	});
</script>

<svelte:head>
	<title>{$headerTitleHome}</title>
</svelte:head>

<Vitrine vitrines={vitrines} showDots={true} showArrows={false} vitrineHeight="460px"/>

<section class="busca">
	<div class="container">	
		<Busca on:filter={search} />
	</div>
</section>


<!-- Destaques Alugar -->
<section class="section destaques-home destaques-home--locacao">
	<div class="container">
		<div class="header pb-25">
			<div class="flex flex-center" style="width: 100%;">
				<div class="flex-1 hidden-sm hidden-xs"></div>
				<h2 class="title">
					Destaques para <a href="{$linkPesquisaLocacao}" class="color-accent">alugar</a>
				</h2>
				<div class="flex-1 hidden-sm hidden-xs text-right">
					<a class="text-bold" href="{$linkPesquisaLocacao}">Veja mais ofertas <i class="fas fa-arrow-alt-circle-right color-accent"></i></a>
				</div>
			</div>
		</div>
		<ListaImoveis pageSize={9} filters={filtrosDestaquesLocacao} showPaginator={false} afterLoadRealties={activateSlickLocacao} />
		<div class="flex flex-center">
			<a class="text-bold pt-20 pb-20 hidden-lg hidden-md" href="{$linkPesquisaLocacao}">Veja mais ofertas <i class="fas fa-arrow-alt-circle-right color-accent"></i></a>
		</div>
	</div>
</section>

<section class="section info aplicativo background-gray">
	<a name="aplicativo"></a>
	<div class="container container-short">
		<div class="items flex sm-flex-column">
			<div class="image flex-1 top  hidden-lg hidden-md" style="background-image: url('assets/images/mockup.png')"></div>
			<div class="content flex-1 flex flex-column gap-20">
				<div class="flex flex-column flex-start">
					<h2 class="header inline">Aplicativo <span class="color-accent">São Pedro imóveis</span></h2>
					<p>Todos os serviços em um único lugar!<br />Utilize no seu celular, tablet ou computador.<br />Comunicação rápida, prática e segura.</p>
					<div class="flex flex-start gap-10">
						<a href="{$linkConheca}" target="_blank" class="btn btn-secondary">CONHEÇA</a>
						<a href="{$linkAV}" target="_blank" class="btn btn-primary">ACESSE AGORA</a>
					</div>
				</div>
			</div>
			<div class="image flex-1 right hidden-sm hidden-xs" style="background-image: url('assets/images/mockup.png')"></div>
		</div>
	</div>
</section>


<!-- Destaques Comprar -->
<section class="section destaques-home destaques-home--vendas">
	<div class="container">
		<div class="header pb-25">
			<div class="flex flex-center" style="width: 100%;">
				<div class="flex-1 hidden-sm hidden-xs"></div>
				<h2 class="title">
					Destaques para <a href="{$linkPesquisaVendas}" class="color-accent">comprar</a>
				</h2>
				<div class="flex-1 hidden-sm hidden-xs text-right">
					<a class="text-bold" href="{$linkPesquisaVendas}">Veja mais ofertas <i class="fas fa-arrow-alt-circle-right color-accent"></i></a>
				</div>
			</div>
		</div>
		<ListaImoveis pageSize={9} filters={filtrosDestaquesVendas} showPaginator={false} afterLoadRealties={activateSlickVendas} />
		<div class="flex flex-center">
			<a class="text-bold pt-20 pb-20 hidden-lg hidden-md" href="{$linkPesquisaVendas}">Veja mais ofertas <i class="fas fa-arrow-alt-circle-right color-accent"></i></a>
		</div>
	</div>
</section>

<section class="section info sobre">
	<a name="sobre"></a>
	<div class="container container-short">
		<div class="items flex sm-flex-column gap-20">
			<div class="image flex-1 top hidden-lg hidden-md" style="background-image: url('assets/images/fachada.jpg')"></div>
			<div class="image flex-1 left hidden-sm hidden-xs" style="background-image: url('assets/images/fachada.jpg')"></div>
			<div class="content flex-1 flex flex-column">
				<div class="flex flex-column flex-start">
					<h2 class="header inline">Sobre a <span class="color-accent">São Pedro Imóveis</span></h2>
					<p>Atuando no mercado imobiliario de Porto Alegre desde 2005, a São Pedro Imóveis possui larga experiência na administração de condomínios, aluguéis, compra e venda de imóveis, buscando sempre inovar e aprimorar o atendimento dos seus clientes.</p>
					<div class="flex flex-start gap-10">
						<a href="/sobre" target="_blank" class="btn btn-secondary">SAIBA MAIS</a>
						<a href="/contato" target="_blank" class="btn btn-primary">ENTRE EM CONTATO</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>

<section class="section ajuda">
	<div class="container container-short">
		<div class="header">
			<h2 class="header pb-0 mb-0">Como podemos ajudar você hoje?</h2>
			<h2 class="header color-secondary">Encontre aqui o que você procura</h2>
		</div>
		<div class="links">
			<a class="link" href="/anuncie">
				<i class="fas fa-megaphone"></i>
				<p>ANUNCIE AQUI<br class="hidden-sm hidden-xs"/> SEU IMÓVEL</p>
			</a>
			<a class="link" href="/contato">
				<i class="fas fa-headset"></i>
				<p>ENTRE EM<br class="hidden-sm hidden-xs"/> CONTATO</p>
			</a>
			<a class="link" href="{$linkSolicite}" target="_blank">
				<i class="fas fa-user-lock"></i>
				<p>SOLICITE SEU<br class="hidden-sm hidden-xs"/> USUÁRIO E SENHA</p>
			</a>
			<a class="link" href="{$linkAV}" target="_blank">
				<i class="fas fa-barcode-alt"></i>
				<p>ACESSE BOLETOS<br class="hidden-sm hidden-xs"/> E EXTRATOS</p>
			</a>
		</div>
	</div>
</section>

<Boleto />
<PopUp channel="site" />